<div class="prompts-wrapper">
	<div class="prompts-container">
		<div class="prompts-left">
			<span class="prompt-title">{{ promptsData[0].event?.title }}</span>
			<span class="prompt-description">{{ promptsData[0].event?.subtitle }}</span>
		</div>
		<div class="prompts-right">
			@if(promptsData[0].event.name === "web3-token-pre-merge" || promptsData[0].event.name ===
			"web3-token-post-merge") {
			<div class="prompt-button">
				<button class="btn btn-primary btn-inverse button" (click)="onDoItLaterClicked()">{{
					"do_it_later" | translate
				}}</button>
			</div>
			}
			<div class="prompt-button">
				<button
					class="btn btn-primary button"
					(click)="onButtonClicked(promptsData[0].event?.targetPath, promptsData[0].id)"
					>{{ promptsData[0].event?.buttonTitle }}</button
				>
			</div>
		</div>
	</div>
</div>
